<!-- Menu header -->
<div class="navbar-header">
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item mr-auto">
      <!-- App Branding -->
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>

    <!-- Menu Toggler -->
    <li class="nav-item nav-toggle">
      <a class="nav-link modern-nav-toggle d-none d-xl-block pr-0" (click)="toggleSidebarCollapsible()">
        <i
          [ngClass]="isCollapsed === true ? 'icon-circle' : 'icon-disc'"
          class="toggle-icon feather font-medium-4 collapse-toggle-icon text-primary"
        ></i>
      </a>
      <a class="nav-link modern-nav-toggle d-block d-xl-none pr-0" (click)="toggleSidebar()">
        <i data-feather="x" class="font-medium-4 text-primary toggle-icon"></i>
      </a>
    </li>
  </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled }"></div>

<!-- Notification Item (Before Main Menu, styled as Menu Item) -->
<div class="sidebar-notification-wrap">
  <ul class="navigation navigation-main">
    <li class="nav-item mt-0">
      <a class="d-flex align-items-center cursor-pointer" (click)="openNotificationModal(notificationModal)">
        <lucide-angular
          *ngIf="unreadNotificationsCount > 0"
          name="bell-ring"
          size="20"
          class="text-danger mr-0"
        ></lucide-angular>
        <lucide-angular *ngIf="unreadNotificationsCount === 0" name="bell" size="20" class="mr-0"></lucide-angular>
        <span class="menu-title text-truncate">Thông báo</span>
        <span class="badge badge-pill badge-danger ml-auto" *ngIf="unreadNotificationsCount > 0">
          {{ unreadNotificationsCount }}
        </span>
      </a>
    </li>
  </ul>
</div>
<!--/ Notification Item -->

<!-- Main menu -->
<div class="main-menu-content" #menuContent (scroll)="onSidebarScroll()">
  <ul class="navigation navigation-main" layout="vertical" core-menu></ul>
</div>
<!--/ Main menu -->

<!-- Sidebar Footer Component -->
<app-sidebar-footer [isCollapsed]="isCollapsed"></app-sidebar-footer>
<!--/ Sidebar Footer Component -->

<!-- Notification Modal Template -->
<ng-template #notificationModal let-modal>
  <div class="modal-body p-0" style="max-height: 480px; overflow-y: auto">
    <div class="list-group list-group-flush">
      <a
        class="list-group-item list-group-item-action p-1 border-bottom"
        href="javascript:void(0)"
        *ngFor="let item of notifications.systemMessages"
      >
        <div class="media d-flex align-items-start">
          <div class="media-left mr-1">
            <div
              class="avatar"
              [ngClass]="{
                'bg-light-danger': item.icon === 'x',
                'bg-light-success': item.icon === 'check',
                'bg-light-warning': item.icon === 'alert-triangle'
              }"
            >
              <div class="avatar-content"><i [data-feather]="item.icon"></i></div>
            </div>
          </div>
          <div class="media-body w-100">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="media-heading mb-0 font-weight-bold" [innerHTML]="item.heading"></h6>
              <small class="ml-auto font-small-2" *ngIf="item.time">{{ item.time }}</small>
            </div>
            <p class="notification-text mb-0 mt-25 font-small-2">{{ item.text }}</p>
          </div>
        </div>
      </a>
      <div class="p-3 text-center font-small-2" *ngIf="!notifications.systemMessages?.length">
        Không có thông báo mới
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="modal.close()">Đóng</button>
  </div>
</ng-template>
